<template>
  
  <div>
    <v-autocomplete
      clearable
      :label="$t('CENTER')"
      :items="items"
      item-text="CenterName"
      item-value="ID"
      v-model="val"
      :rules="rules"
      return-object
      :placeholder="placeholder"
      
    >
    </v-autocomplete>
  </div>
  
</template>

<script>
import auth from "@/api/auth";
import snackbar from "@/components/app/customcomp/snackbarcomp";
export default {
  props: {
    value: {},
    rules:{
      typeof:Array,
      default:[]
    },
    isCoper:{
      type:Boolean,
      default:false
    },
    coperDate:{
    }
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    placeholder() {
      if (this.items.length==0)
      {
        return 'Merkez Bulunamadı..';
      }
      else
      {
        return this.$t('Please-Choose');
      }
   }
  },
  data() {
    return {
     
      loading: false,
      searchMerkez: null,
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
      text1: '',
      snackbar: false
    };
  },
  components: {
     
      snackbar,
     
    },
  mounted() {
     this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      this.text1='';
      this.items=[];
      var params = {};
      if(this.isCoper == true){
      let coperParams = {
        Coper : true,
        CoperTarih : this.coperDate,
        CompanyID : this.credentials.CoperSirketNo
      };
      params = coperParams;
      }else{
        let muhasebePrms= {
          CompanyId : this.credentials.MuhasebeSirketNo
        }
        params=muhasebePrms;
      }
      console.log(params);
      this.$http
        .post(
          auth.API_URL + "api/AccountingDefinitions/AccountingCenterList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
          
            this.items = response.body;
            this.loading = false;
          },
          (response) => {
           
            if (response.status == 0 ) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loading = false;
            } else {
          
              alert('Seçili Tarih ve Cari Şirket İçin Muhasebe Firması Bulunamadı');
             
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loading = false;
            }
          }
        
        )  
    },
  },
};
</script>

<style>
</style>